import { render, staticRenderFns } from "./History.vue?vue&type=template&id=dd3c16f2"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd3c16f2')) {
      api.createRecord('dd3c16f2', component.options)
    } else {
      api.reload('dd3c16f2', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=dd3c16f2", function () {
      api.rerender('dd3c16f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Academy/History.vue"
export default component.exports